// extracted by mini-css-extract-plugin
export default {"overview":"OverviewTable_overview__k5NxE"};